// Preload critical assets to avoid display issues on initial load
export function preloadImages() {
  try {
    const images = [
      require('@/assets/logos/FH_CEFoodCycle_Logo.png'),
      require('@/assets/logos/CEFoodCycle_Interreg.png'),
      require('@/assets/logos/Partnerlogos.jpeg')
    ];

    // Preload images without blocking
    images.forEach(src => {
      const img = new Image();
      img.src = src;
      // Add to DOM temporarily to force load
      img.style.position = 'absolute';
      img.style.left = '-9999px';
      img.style.width = '1px';
      img.style.height = '1px';
      document.body.appendChild(img);
      
      // Remove after load
      img.onload = () => {
        setTimeout(() => {
          if (img.parentNode) {
            img.parentNode.removeChild(img);
          }
        }, 100);
      };
      
      img.onerror = () => {
        console.warn('Failed to preload image:', src);
        if (img.parentNode) {
          img.parentNode.removeChild(img);
        }
      };
    });
  } catch (error) {
    console.warn('Error preloading images:', error);
  }
}

export function ensureBootstrapIconsLoaded() {
  // Force load Bootstrap Icons font
  try {
    // Create a test element with Bootstrap icon
    const testElement = document.createElement('i');
    testElement.className = 'bi bi-check';
    testElement.style.position = 'absolute';
    testElement.style.left = '-9999px';
    testElement.style.fontSize = '1px';
    testElement.style.visibility = 'hidden';
    document.body.appendChild(testElement);
    
    // Check if font is loaded
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        console.log('Bootstrap Icons font loaded');
        // Clean up test element
        setTimeout(() => {
          if (testElement.parentNode) {
            testElement.parentNode.removeChild(testElement);
          }
        }, 100);
      }).catch(err => {
        console.warn('Font loading issue:', err);
      });
    } else {
      // Fallback for browsers without Font Loading API
      setTimeout(() => {
        if (testElement.parentNode) {
          testElement.parentNode.removeChild(testElement);
        }
      }, 1000);
    }
  } catch (error) {
    console.warn('Error checking Bootstrap Icons:', error);
  }
}

// Combined preload function - non-blocking
export function preloadAllAssets() {
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      preloadImages();
      ensureBootstrapIconsLoaded();
    });
  } else {
    preloadImages();
    ensureBootstrapIconsLoaded();
  }
}